import pinchZoom from "./pinchZoom";
const zoomInit = () => {
    if(document.querySelector('.kirinus-zoom-image')){
        const allImages = document.querySelectorAll('.kirinus-zoom-image');
        allImages.forEach(image => {
           pinchZoom(image);
        })
    }

}
export default zoomInit;